"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerBomMergeUploadedDatasheetUnusedEvent = exports.CustomerBomMergeFailedEvent = exports.CustomerBomMergeCompletedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
const customer_bom_merge_enums_1 = require("./customer-bom-merge-enums");
exports.CustomerBomMergeCompletedEvent = (0, event_1.createEventClass)('CustomerBomMergeCompletedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    newPackagesCreated: zod_1.z.number(),
    bomItemsResolvedBefore: zod_1.z.number(),
    bomItemsResolvedAfter: zod_1.z.number(),
    moduleGroupsResolvedBefore: zod_1.z.number(),
    moduleGroupsResolvedAfter: zod_1.z.number(),
    moduleGroupsWithChangedPackageId: zod_1.z.number(),
}));
exports.CustomerBomMergeFailedEvent = (0, event_1.createEventClass)('CustomerBomMergeFailedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    phase: zod_1.z.nativeEnum(customer_bom_merge_enums_1.CustomerBomMergeFailurePhase),
    errorName: zod_1.z.string(),
    errorMessage: zod_1.z.string(),
}));
exports.CustomerBomMergeUploadedDatasheetUnusedEvent = (0, event_1.createEventClass)('CustomerBomMergeUploadedDatasheetUnusedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    fileId: zod_1.z.string(),
    packageId: zod_1.z.string().nullable(),
    bomItemCount: zod_1.z.number(),
    reason: zod_1.z.nativeEnum(customer_bom_merge_enums_1.CustomerBomMergeUploadUnusedReason),
}));
//# sourceMappingURL=customer-bom-merge-events.js.map